<google-map height="100%" width="100%" [options]="mapOptions!" (mapInitialized)="onMapReady()">
  <map-marker *ngIf="address" [position]="address" [options]="markerOptions"></map-marker>
  <map-circle *ngIf="address && showRadius" [center]="address" [radius]="radius" [options]="circleOptions" />
</google-map>
